import { makeStyles } from "@material-ui/core"
import { themeColors } from "letalkui"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(() => ({
	"@keyframes swapOut": {
		"0%": { opacity: 1, transform: "translateY(0)" },
		"100%": { opacity: 0, transform: "translateY(-8px)" }
	},
	"@keyframes swapIn": {
		"0%": { opacity: 0, transform: "translateY(10px)" },
		"100%": { opacity: 1, transform: "translateY(0)" }
	},
	"@keyframes modalIn": {
		"0%": { opacity: 0, transform: "scale(0.96)" },
		"100%": { opacity: 1, transform: "scale(1)" }
	},
	"@keyframes blink": {
		"0%, 100%": { opacity: 1 },
		"50%": { opacity: 0.25 }
	},
	"@keyframes floatBlob": {
		"0%, 100%": { transform: "translate(0, 0) rotate(0deg)" },
		"33%": { transform: "translate(12px, -8px) rotate(3deg)" },
		"66%": { transform: "translate(-8px, 10px) rotate(-2deg)" }
	},
	"@keyframes coinPop": {
		"0%": { opacity: 0, transform: "scale(0.5)" },
		"60%": { opacity: 1, transform: "scale(1.1)" },
		"100%": { opacity: 1, transform: "scale(1)" }
	},
	dialogPaper: {
		borderRadius: "20px",
		boxShadow: `0 32px 80px ${ColorUtil.hexToRgba(colors.gray[950], 0.35)}`,
		overflow: "hidden",
		padding: 0,
		transition: "width 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
		maxWidth: "none !important"
	},
	backdrop: {
		backgroundColor: ColorUtil.hexToRgba(colors.purple[950], 0.45),
		backdropFilter: "blur(1.5px)",
		WebkitBackdropFilter: "blur(1.5px)"
	},
	dialogContent: {
		padding: 0,
		overflow: "hidden"
	},
	screenContainer: {
		position: "relative",
		overflow: "hidden"
	},
	screenSwappingOut: {
		animation: "$swapOut 200ms ease-in forwards"
	},
	screenSwappingIn: {
		animation: "$swapIn 340ms cubic-bezier(0.4, 0, 0.2, 1) forwards"
	},
	screenModalIn: {
		animation: "$modalIn 340ms ease-out forwards"
	},
	closeButton: {
		position: "absolute",
		top: 16,
		right: 16,
		zIndex: 4,
		width: 32,
		height: 32,
		borderRadius: "50%",
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		cursor: "pointer",
		border: "none",
		backgroundColor: "transparent",
		color: themeColors.colors.system.gray[400],
		fontSize: 16,
		transition: "background-color 0.2s ease",
		"&:hover": {
			backgroundColor: themeColors.colors.system.gray[50]
		}
	},
	closeButtonOnHeader: {
		backgroundColor: ColorUtil.hexToRgba(colors.gray[50], 0.15),
		color: themeColors.colors.system.gray[50],
		"&:hover": {
			backgroundColor: ColorUtil.hexToRgba(colors.gray[100], 0.3)
		}
	},
	closeButtonGlyph: {
		fontSize: 16,
		lineHeight: 1
	},
	placeholderContent: {
		padding: 40,
		textAlign: "center"
	}
}))

export default useStyles
